/* 🤖 this file was generated by svg-to-ts */
export const mgcIconYSkewFilled: {
  name: 'y-skew-filled';
  data: string;
} = {
  name: 'y-skew-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.34 4.047c-.504.096-1.097.542-1.348 1.013-.065.122-.826 2.712-1.956 6.66-1.782 6.222-1.85 6.473-1.851 6.8-.001.284.017.378.104.569.146.317.427.605.746.761l.263.13H20.7l.229-.107c.596-.279.973-.925.893-1.528-.046-.347-3.698-13.066-3.814-13.285-.26-.488-.846-.918-1.385-1.017-.304-.055-8.99-.052-9.283.004"/></svg>`
};
